import React, { useState } from "react";
import Boiler from "./BoilerDetails";
import Pumps from "./PumpDetails";
import ShipCompressorDetails from "./CompressorDetails";
import ShipPurifierDetails from "./PurifierDetails";
import AuxiliaryMachinary from "./AuxiliaryMachinary";

function SubTabMachinary({ id, onSuccess }) {
  const [activeTab, setActiveTab] = useState("boilers");

  const handleClick = (name) => {
    setActiveTab(name);
    localStorage.setItem("engineLogbook", name);
  };

  const handleSubSuccess = (currentSubTab) => {
    const subTabOrder = ["boilers", "purifier", "pump", "compressor", "auxiliaryMachinary"];
    const currentIndex = subTabOrder.indexOf(currentSubTab);
    if (currentIndex !== -1 && currentIndex < subTabOrder.length - 1) {
      const nextSubTab = subTabOrder[currentIndex + 1];
      setActiveTab(nextSubTab);
      localStorage.setItem("engineLogbook", nextSubTab);
      window.scrollTo(0, 0);
    } else if (currentIndex === subTabOrder.length - 1) {
      if (onSuccess) onSuccess();
    }
  };

  return (
    <>
      <div className="white-containers">
        <ul className="sub-marine-tabs">
          <li
            className={activeTab === "boilers" ? "active" : ""}
            onClick={() => handleClick("boilers")}
          >
            Boiler
          </li>
          <li
            className={activeTab === "purifier" ? "active" : ""}
            onClick={() => handleClick("purifier")}
          >
            Purifier
          </li>

          <li className={activeTab === "pump" ? "active" : ""} onClick={() => handleClick("pump")}>
            Pump
          </li>
          <li
            className={activeTab === "compressor" ? "active" : ""}
            onClick={() => handleClick("compressor")}
          >
            Air Compressor
          </li>
          <li
            className={activeTab === "auxiliaryMachinary" ? "active" : ""}
            onClick={() => handleClick("auxiliaryMachinary")}
          >
            Other Machinary
          </li>
        </ul>
      </div>
      <div className="white-container-contant">
        {activeTab == "auxiliaryMachinary" && (
          <AuxiliaryMachinary id={id} onSuccess={() => handleSubSuccess("auxiliaryMachinary")} />
        )}
        {activeTab == "boilers" && <Boiler id={id} onSuccess={() => handleSubSuccess("boilers")} />}
        {activeTab == "pump" && <Pumps id={id} onSuccess={() => handleSubSuccess("pump")} />}
        {activeTab == "compressor" && (
          <ShipCompressorDetails id={id} onSuccess={() => handleSubSuccess("compressor")} />
        )}
        {activeTab == "purifier" && (
          <ShipPurifierDetails id={id} onSuccess={() => handleSubSuccess("purifier")} />
        )}
      </div>
    </>
  );
}

export default SubTabMachinary;
